function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useEffect, useState } from 'react';
import RecipientLanguage from "./ModuleSettings/RecipientLanguage";
import SignatureMethod from "./ModuleSettings/SignatureMethod.js";
import { Button } from '@signicat/designi/components/buttons';
import { t } from "../../helpers/i18n";
import { module as moduleActions } from "../../store/actions";
import { useDispatch, useSelector } from 'react-redux';
import { Row, Column } from '@signicat/designi/components/layout';
import { Spinner } from '@signicat/designi/components/loaders';
import { Message } from '@signicat/designi/components/messages';
import SmsSender from "./ModuleSettings/smsSender";
var ModuleSettings = function ModuleSettings() {
  var _useSelector = useSelector(function (state) {
      return state.module.settings;
    }),
    signature = _useSelector.signature,
    isLoading = _useSelector.isLoading,
    saveStatus = _useSelector.saveStatus,
    loadingFailure = _useSelector.loadingFailure;
  var moduleIsLoaded = useSelector(function (state) {
    var _state$module$isLoade, _state$module;
    return (_state$module$isLoade = (_state$module = state.module) === null || _state$module === void 0 ? void 0 : _state$module.isLoaded) !== null && _state$module$isLoade !== void 0 ? _state$module$isLoade : false;
  });
  var _useState = useState(saveStatus),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var dispatch = useDispatch();
  var _useState3 = useState(signature),
    _useState4 = _slicedToArray(_useState3, 2),
    settings = _useState4[0],
    setSettings = _useState4[1];
  var isAdmin = settings === null || settings === void 0 ? void 0 : settings.currentUserIsAdmin;
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    customSMSNotificationEnabled = _useState6[0],
    setCustomSMSNotificationEnabled = _useState6[1];
  useEffect(function () {
    dispatch(moduleActions.loadModuleSettings());
    dispatch(moduleActions.getDependencies());
  }, []);
  useEffect(function () {
    setStatus(saveStatus);
  }, [saveStatus]);
  useEffect(function () {
    setSettings(signature);
  }, [signature]);
  var handleLanguageChange = function handleLanguageChange(language) {
    var updateSettings = _objectSpread({}, settings);
    updateSettings.defaultRecipientLanguage = language;
    setSettings(updateSettings);
  };
  var handleSmsSenderChange = function handleSmsSenderChange(smsSender) {
    var updateSettings = _objectSpread({}, settings);
    updateSettings.smsSender = smsSender;
    setSettings(updateSettings);
  };
  var handleOnSignMethodsChange = function handleOnSignMethodsChange(signMethods) {
    var updateSettings = _objectSpread({}, settings);
    updateSettings.defaultSignatureMethods = signMethods;
    setSettings(updateSettings);
  };
  var handleSaveSettingsClick = function handleSaveSettingsClick() {
    if (settingsIsValid()) {
      dispatch(moduleActions.saveModuleSettings(settings));
    }
  };
  var settingsIsValid = function settingsIsValid() {
    if (settings.smsSender && !settings.smsSender.match(/^[A-Za-z\d]+$/)) {
      setStatus('module_settings_validation_error_sms_sender');
      return false;
    }
    return true;
  };
  var loadedResult = loadingFailure || !moduleIsLoaded ? /*#__PURE__*/React.createElement(Message, {
    variant: "error"
  }, "Error loading settings, please try again later") : /*#__PURE__*/React.createElement(Fragment, null, isAdmin ? null : /*#__PURE__*/React.createElement(Message, {
    variant: "warning",
    icon: "warning"
  }, t('module_settings_not_admin_warning')), /*#__PURE__*/React.createElement(RecipientLanguage, {
    defaultLanguage: settings.defaultRecipientLanguage,
    setSelectedLanguage: handleLanguageChange,
    disabled: !isAdmin
  }), /*#__PURE__*/React.createElement(SignatureMethod, {
    defaultMethods: settings.defaultSignatureMethods,
    onSignMethodsChange: handleOnSignMethodsChange,
    mechanism: settings.mechanism,
    disabled: !isAdmin
  }), /*#__PURE__*/React.createElement(SmsSender, {
    smsSender: settings.smsSender,
    setSmsSender: handleSmsSenderChange,
    disabled: !isAdmin
  }), /*#__PURE__*/React.createElement(Row, {
    paddingTop: "32px"
  }, /*#__PURE__*/React.createElement(Column, {
    direction: "row"
  }, status ? /*#__PURE__*/React.createElement(Message, {
    variant: status === 'module_settings_save_success' ? 'info' : 'error'
  }, t(status)) : null), /*#__PURE__*/React.createElement(Column, {
    direction: "row",
    justifyContent: "flex-end"
  }, isAdmin ? /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: handleSaveSettingsClick,
    fullWidth: true
  }, t('button_text_save')) : null)));
  return isLoading === true || !moduleIsLoaded ? /*#__PURE__*/React.createElement(Spinner, {
    fullscreen: true
  }) : loadedResult;
};
export default ModuleSettings;